import { Box } from '../../UI/Box'
import { Strong } from '../Typeography'

export function EthIconLabel() {
  return (
    <Box g={8} c fu aw>
      <img alt="ETH" src="/memecoin-launcher/currency/eth.svg" />
      <Strong c="text-secondary">ETH</Strong>
    </Box>
  )
}
